import React from "react"
import { UncontrolledTooltip, Card } from "reactstrap"

import DatetimeRenderer from "../../Material/DatetimeRenderer"
import UpdateIncidentDocumentInfo from "../Components/UpdateIncidentDocumentInfo"
import toTitleCase from "../../Functions/toTitleCase"
import { cleanDocumentUrl, isImage } from "../../Material/DocumentModal/DocumentsListNew"
import withApolloClient from "../../withApolloClient"
import "./DocumentsTab.css"

class DocumentDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    isVideo(url, document) {
        if (!url && !document) return false
        const videoExts = ['.mp4', '.mov']
        const lowerUrl = (url || '').toLowerCase()
        const lowerDoc = (document || '').toLowerCase()
        return videoExts.some(ext => lowerUrl.endsWith(ext) || lowerDoc.endsWith(ext))
    }

    isPdf(url, document) {
        if (!url && !document) return false
        const lowerUrl = (url || '').toLowerCase()
        const lowerDoc = (document || '').toLowerCase()
        return lowerUrl.includes(".pdf") || lowerDoc.endsWith(".pdf")
    }

    render() {
        const { document, refetchQuery, isLoading } = this.props
        const docKey = document?.pk || "incident-doc"
        const docTypeLabel = document.documentType ? toTitleCase(document.documentType.typeName) : "--"
        const notesPreview = document.notes
            ? document.notes.split(" ").length > 6
                ? document.notes.split(" ").slice(0, 6).join(" ") + "..."
                : document.notes
            : "---"
        return (
            <Card className="DocumentCard incident-doc-card" key={docKey}>
                <div className="DocumentCardHeader incident-doc-header">
                    <p className="incident-doc-title mb-0">
                        <i className={document.document && document.document.toUpperCase().slice(-4) === ".PDF" ? "fa fa-file-pdf-o" : "fa fa-picture-o"} aria-hidden="true" />&nbsp;{docTypeLabel}
                    </p>
                    <div className="incident-doc-actions">
                        <input
                            type="checkbox"
                            className="doc-select-checkbox"
                            checked={this.props.isSelected}
                            disabled={isLoading}
                            onChange={() => this.props.toggleSelectDoc(document)}
                        />
                        <i className="fa fa-arrows-alt" onClick={() => !isLoading && this.props.viewDocuments()} title="Preview Document" />
                    </div>
                </div>
                <div className="DocumentCardPreview">
                    {document ? (
                        this.isVideo(document.url, document.document) ?
                            <video className="DocumentCardPreviewEmbed DocViewerVideo" src={document.url} controls style={{ maxWidth: '100%', maxHeight: 180 }} /> :
                            isImage(cleanDocumentUrl(document.url), document.document) ?
                                <img className="DocumentCardPreviewEmbed DocViewerImage" src={document.url} alt="Document" /> :
                                this.isPdf(cleanDocumentUrl(document.url), document.document) ?
                                    <iframe scrolling="no" className="DocumentCardPreviewEmbed" src={cleanDocumentUrl(document.url)} title={`document-iframe-${docKey}`} /> :
                                    <div className="DocumentCardPreviewEmbed d-flex align-items-center justify-content-center">
                                        <div className="text-center px-2">
                                            <i className="fa fa-file-text-o fa-2x mb-2" aria-hidden="true" />
                                            <div>Preview isn’t available here. Click expand icon to view or download the document.</div>
                                        </div>
                                    </div>
                    ) : ''}
                </div>
                <div className="incident-doc-footer">
                    <p className="incident-doc-text mb-1">
                        Uploaded at <b style={{ color: "#374151" }}>{document.dateAdded ? <DatetimeRenderer datetime={document.dateAdded} /> : "--"}</b> by <b style={{ color: "#374151" }}>{document.createdBy?.username || "--"}</b>
                    </p>
                    <p className="incident-doc-text mb-0">
                        <span id={`docNotesTooltip_${docKey}`}>
                            <b style={{ color: "#374151" }}>Notes: </b>{notesPreview}&nbsp;&nbsp;
                        </span>
                        {!!document.notes && (
                            <UncontrolledTooltip placement="top" target={`docNotesTooltip_${docKey}`}>
                                {document.notes}
                            </UncontrolledTooltip>
                        )}
                        <span className="doc-action-chip" id={`edit_document_notes_${docKey}`} onClick={() => !isLoading && this.setState({ openModal: `edit_document_notes_${docKey}` })} >
                            <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </span>
                        {this.state.openModal === `edit_document_notes_${docKey}` && (
                            <UpdateIncidentDocumentInfo
                                open={true}
                                target={`edit_document_notes_${docKey}`}
                                handleClose={() => this.setState({ openModal: "" })}
                                name={"notes"}
                                value={document.notes || ""}
                                title={"Edit Document Notes"}
                                type="textarea"
                                docId={document.id}
                                refetch={refetchQuery}
                            />
                        )}
                    </p>
                </div>
            </Card >
        )
    }
}

export default withApolloClient(DocumentDetails)
